import { Navigation } from 'zudoku';

const productsItems: Navigation = [
    {
        type: 'link',
        icon: 'codesandbox',
        label: 'CBN Regulatory Sandbox',
        to: 'products/beyond-sandbox'
    },
    {
        type: 'link',
        icon: 'receipt',
        label: 'NRS Tax Compliance Gateway',
        to: 'products/tax-collection-gateway'
    },
    {
        type: 'link',
        icon: 'globe',
        label: 'Third Party APIs',
        to: 'products/third-party-apis'
    }
];

export const sidebar: Navigation = [
    {
        type: 'doc',
        label: 'Quickstart',
        icon: 'circle-play',
        file: 'quickstart'
    },
    {
        type: 'category',
        label: 'Products',
        items: productsItems,
        collapsible: false
    },
    {
        type: 'doc',
        label: 'Support',
        icon: 'circle-question-mark',
        file: 'support'
    }
]
